import httpClient from "../../../client/httpClient";

export const fetchDiscountProducts = async (payload = {}, signal) => {
    const {
        sellerId = null,
        filters = {},
        pagination = { page: 1, pageSize: 5 },
        sorting = { sortBy: "id", sortOrder: "DESC" }
    } = payload;

    try {
        if (!sellerId) {
            throw new Error("SellerId is required");
        }

        const searchParams = filters.name
            ? `sellersId=${sellerId}&productName=${filters.name}`
            : `sellersId=${sellerId}`;

        const res = await httpClient.post(
            `v1/api/product/get-all-discount-products-by-name?${searchParams}`,
            {
                pageNumber: pagination.page || 1,
                pageSize: pagination.pageSize || 5,
                sortBy: sorting.sortBy || "id",
                sortOrder: sorting.sortOrder || "DESC"
            },
            { signal }
        );

        return res.data;
    } catch (error) {
        console.log("Error on fetching discounted products", error);
        throw error;
    }
};
